import React, { useCallback, useEffect, useState } from "react"

import { auth } from "@/components/CopilotAnalyze/api"
import { createSafeContext } from "@/helpers/create-safe-context"

export interface CopilotAuthContext {
    jwt?: string
    isLoading: boolean
    error?: Error
    refresh: () => Promise<void>
}

const [Provider, useCopilotAuthContext] = createSafeContext<CopilotAuthContext>(
    "CopilotAuthProvider component was not found in tree",
)

export { useCopilotAuthContext as useCopilotAuth }

export const CopilotAuthProvider = ({ children }: { children: React.ReactNode }) => {
    const [jwt, setJwt] = useState<string | undefined>()
    const [isLoading, setIsLoading] = useState(true)
    const [error, setError] = useState<Error | undefined>()

    const fetchJwtToken = useCallback(async () => {
        try {
            setIsLoading(true)
            setError(undefined)
            const { jwt } = await auth.fetchJwt()
            setJwt(jwt)
        } catch (err) {
            setError(err instanceof Error ? err : new Error("Failed to fetch Copilot JWT"))
            setJwt(undefined)
        } finally {
            setIsLoading(false)
        }
    }, [])

    useEffect(() => {
        fetchJwtToken()
    }, [fetchJwtToken])

    const state = { jwt, isLoading, error, refresh: fetchJwtToken }

    return <Provider value={state}>{children}</Provider>
}
